import React from 'react';
import clsx from 'clsx';

import Skeleton from '@smart-tv/components/skeleton';

import styles from '../episode-selector.module.scss';

// Enough cards to fill the widest supported viewport without ever running out mid-scroll.
const SKELETON_CARD_COUNT = 8;

interface Props {
  hasSeasonTabs?: boolean;
}

export const SheetEpisodeSelectorSkeleton: React.FC<Props> = ({ hasSeasonTabs = true }) => (
  <div
    className={clsx(styles['episode-list'], styles['episode-list--skeleton'], {
      [styles['episode-list--offset-top']]: !hasSeasonTabs
    })}
    aria-label="Indlæser episoder"
  >
    {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
      <div key={index} className={clsx(styles['episode-card'], styles['episode-card-skeleton'])}>
        <Skeleton
          animation="wave"
          variant="rect"
          className={styles['episode-card__image-wrapper']}
        />
        <div className={styles['episode-card__detail']}>
          <Skeleton
            animation="wave"
            variant="text"
            className={styles['episode-card-skeleton__meta']}
          />
          <Skeleton
            animation="wave"
            variant="text"
            className={styles['episode-card-skeleton__title']}
          />
        </div>
      </div>
    ))}
  </div>
);

SheetEpisodeSelectorSkeleton.displayName = 'SheetEpisodeSelectorSkeleton';

export default React.memo(SheetEpisodeSelectorSkeleton);
